import { Preference } from '@app/core/model/user-preferences.interface'
import { LanguageService } from '@app/core/service/language.service'
import { FeeAmountType, FeeItemInstance } from '@app/features/scope-overview/model/fee-item.model'
import { Money } from '@app/features/scope-overview/model/money.model'
import { ScopeSection } from '@app/features/scope-overview/model/scope-section'
import { ScopeComponent } from '@app/features/scoping/models/component.model'
import { Deliverable } from '@app/features/scoping/models/deliverable.model'
import { TableColumnKey } from '../../ui-components/scope-ui-table/table-column-key.enum'

export const getFeeColumns = (langService: LanguageService) => [
  {
    key: TableColumnKey.FEE_NAME,
    name: `${langService.get('scope|u')} / ${langService.get('deliverable|u')} / ${langService.get('component|u')} FEE`,
    valueIconFunction: () => 'request_quote',
    selected: true,
    isVisibleInList: () => false,
    value: (feeItem: FeeItemInstance) => feeItem.feeItem?.name,
    footerRowValue: (parentEntity: ScopeSection | Deliverable | ScopeComponent) =>
      parentEntity.feeItems?.length ? 'Fee total' : 'No fees defined',
  },
  {
    key: TableColumnKey.AMOUNT,
    name: 'Amount',
    selected: true,
    isVisibleInList: () => false,
    value: (feeItem: FeeItemInstance, parentEntity: ScopeSection | Deliverable | ScopeComponent) =>
      feeItem.feeItem?.amountType === FeeAmountType.PERCENTAGE
        ? feeItem.feeItem?.amount
        : new Money(feeItem.feeItem?.amount, feeItem.currencyUnit || parentEntity?.currencyUnit),
  },
  {
    key: TableColumnKey.PRICE,
    name: 'Price',
    selected: true,
    isVisibleInList: () => false,
    value: (feeItem: FeeItemInstance) => new Money(feeItem.price, feeItem.currencyUnit),
    footerRowValue: (parentEntity: ScopeSection | Deliverable | ScopeComponent) =>
      new Money(parentEntity.getTotalFees(null), parentEntity.currencyUnit),
  },
]

export function getFeeColumnsWithName(columns: Preference[], name: string): Preference[] {
  const feeColumns = columns.map((x) => Object.assign({}, x))
  feeColumns[0].name = name
  return feeColumns
}
